import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatMetricSimple = createCustomElementWrapper('kat-metric-simple', 'KatMetricSimple', {
    'headerClickable': 'header-clickable',
    'trendPolarity': 'trend-polarity',
    'trendValue': 'trend-value',
}, {});
